import React from 'react';
import styled from '@emotion/styled';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { getMediaPath } from 'app/functions';
import ReactHtmlParser from 'react-html-parser';
import theme from 'theme';
import { reduceFontSizePxInHtml } from 'common/utils';

const SocialLinksContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    justifyItems: 'center',
    alignContent: 'center',
    padding: { xs: '10px' },
    width: '100%',
}));

const IconStrip = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  flexWrap: 'wrap',
  gap: '10px',
  marginTop: '0px',
  padding: '10px',
}));

const SocialLink = styled('a')({
  display: 'inline-block',
  textDecoration: 'none',
});

const StyledIcon = styled('img')(({ theme }) => ({
  width: '150px',
  height: '100px',
  transition: 'transform 0.3s ease',
  '&:hover': {
    transform: 'translateY(-5px)',
  },
  [theme.breakpoints.up('sm')]: {
    width: '150px',
    height: '150px',
  },
  [theme.breakpoints.up('md')]: {
    width: '200px',
    height: '150px',
  },
}));

const SmallStyledIcon = styled('img')(({ theme }) => ({
  width: '50px',
  height: '50px',
  transition: 'transform 0.3s ease',
  '&:hover': {
    transform: 'translateY(-5px)',
  },
  [theme.breakpoints.up('sm')]: {
    width: '60px',
    height: '60px',
  },
}));

const BannerImage = styled('img')(({ theme }) => ({
  width: '100%',
  height: 'auto',
  display: 'block',
  margin: '20px auto 0',
  cursor: 'pointer',
}));

const getBannerImage = (banner, bannerMobile,) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  if (isMobile) {
    return bannerMobile;
  }
  return banner;
}

const SocialLinksSection = ({ data }) => {
    const { topText, moreText, icons, banner, bannerMobile, bannerLink } = data;
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const processedTopText = isMobile ? reduceFontSizePxInHtml(topText, 4) : topText;
    const processedMoreText = isMobile ? reduceFontSizePxInHtml(moreText, 4) : moreText;
  return (
    <SocialLinksContainer testID="social-links-section">
      <Typography
        sx={{
          textAlign: 'center',
          marginTop: '20px',
          paddingLeft: { xs: '10px' },
          paddingRight: { xs: '10px' },
        }}
      >
        {ReactHtmlParser(processedTopText)}
      </Typography>
      {(banner || bannerMobile) && bannerLink && (
          <BannerImage src={getMediaPath(getBannerImage(banner, bannerMobile))} alt="banner" onClick={() => window.open(bannerLink, '_blank')}/>
      )}
      <Typography sx={{  textAlign: 'center', marginTop: '20px', paddingLeft: { xs: '10px' }, paddingRight: { xs: '10px' } }}>
        {ReactHtmlParser(processedMoreText)}
      </Typography>
      <IconStrip>
        {icons.filter(icon => icon.type === 1).map(icon => (
          <SocialLink key={icon.name}>
            <SmallStyledIcon onClick={(event) => { event.preventDefault(); window.open(icon.link, '_blank'); }} src={getMediaPath(icon.icon)} alt={icon.name} testID={`small-social-icon-${icon.name}`} />
          </SocialLink>
        ))}
      </IconStrip>
    </SocialLinksContainer>
  );
};

export default SocialLinksSection; 